/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TrackItMeasurementParameterFilterWithMatchingValueDto } from './TrackItMeasurementParameterFilterWithMatchingValueDto';
import {
    instanceOfTrackItMeasurementParameterFilterWithMatchingValueDto,
    TrackItMeasurementParameterFilterWithMatchingValueDtoFromJSON,
    TrackItMeasurementParameterFilterWithMatchingValueDtoFromJSONTyped,
    TrackItMeasurementParameterFilterWithMatchingValueDtoToJSON,
} from './TrackItMeasurementParameterFilterWithMatchingValueDto';
import type { TrackItMeasurementParameterFilterWithUserValueDto } from './TrackItMeasurementParameterFilterWithUserValueDto';
import {
    instanceOfTrackItMeasurementParameterFilterWithUserValueDto,
    TrackItMeasurementParameterFilterWithUserValueDtoFromJSON,
    TrackItMeasurementParameterFilterWithUserValueDtoFromJSONTyped,
    TrackItMeasurementParameterFilterWithUserValueDtoToJSON,
} from './TrackItMeasurementParameterFilterWithUserValueDto';
import type { TrackItMeasurementPropertyFilterDto } from './TrackItMeasurementPropertyFilterDto';
import {
    instanceOfTrackItMeasurementPropertyFilterDto,
    TrackItMeasurementPropertyFilterDtoFromJSON,
    TrackItMeasurementPropertyFilterDtoFromJSONTyped,
    TrackItMeasurementPropertyFilterDtoToJSON,
} from './TrackItMeasurementPropertyFilterDto';

/**
 * @type TrackItMeasurementFilterForCombinationDto
 * 
 * @export
 */
export type TrackItMeasurementFilterForCombinationDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithMatchingValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItMeasurementParameterFilterWithMatchingValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithUserValueDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItMeasurementParameterFilterWithUserValueDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementPropertyFilterDto, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItMeasurementPropertyFilterDto;


export function TrackItMeasurementFilterForCombinationDtoFromJSON(json: any): TrackItMeasurementFilterForCombinationDto {
    return TrackItMeasurementFilterForCombinationDtoFromJSONTyped(json, false);
}

export function TrackItMeasurementFilterForCombinationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItMeasurementFilterForCombinationDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithMatchingValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItMeasurementParameterFilterWithMatchingValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithMatchingValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithUserValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItMeasurementParameterFilterWithUserValueDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithUserValueDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementPropertyFilterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItMeasurementPropertyFilterDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementPropertyFilterDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of TrackItMeasurementFilterForCombinationDto exists with '$type=${json['$type']}'`);
    }
}

export function TrackItMeasurementFilterForCombinationDtoToJSON(value?: TrackItMeasurementFilterForCombinationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithMatchingValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItMeasurementParameterFilterWithMatchingValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementParameterFilterWithUserValueDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItMeasurementParameterFilterWithUserValueDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.TrackItMeasurementPropertyFilterDto, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItMeasurementPropertyFilterDtoToJSON(value);
        default:
            throw new Error(`No variant of TrackItMeasurementFilterForCombinationDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the TrackItMeasurementFilterForCombinationDto interface.
 */
export function instanceOfTrackItMeasurementFilterForCombinationDto(value: any): value is TrackItMeasurementFilterForCombinationDto {
    if (instanceOfTrackItMeasurementParameterFilterWithMatchingValueDto(value)) return true;
    if (instanceOfTrackItMeasurementParameterFilterWithUserValueDto(value)) return true;
    if (instanceOfTrackItMeasurementPropertyFilterDto(value)) return true;
    return false;
}

